import { HairLength } from 'drycut-graphql';
import { Controller } from 'react-hook-form';
import { ToggleButtonGroup } from 'ui-components';

type Props = {
  name: string;
};

export default function ControlledHairLengthToggle({ name }: Props): JSX.Element {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <ToggleButtonGroup
          onChange={onChange}
          options={[
            { label: 'Kurzhaar', value: HairLength.Short },
            { label: 'Langhaar', value: HairLength.Long },
          ]}
          selected={value}
        />
      )}
    />
  );
}
